import ApiUrl from "../../configTools/apiUrl";

const Kaayclosetpage = (page,setPage,items,setItems,setHasMore)=>{
  fetch(ApiUrl.API_URL_Kaaycloset+"/"+page)
  .then(res=>res.json())
  .then(data =>{
      if(data.success){
          if(data.responce.length === 0){
              setHasMore(false);
            }
            else{
              var sendData = [];
              for (let index = 0; index < items.length; index++) {
                const element = items[index];
                sendData.push(element);
              }
              for (let index = 0; index < data.responce.length; index++) {
                const element = data.responce[index];
                sendData.push(element);
              }
              setItems(sendData);
              setPage(page+1);
            }
      }
  })
}

const Artncraftpage = (page,setPage,items,setItems,setHasMore)=>{
  fetch(ApiUrl.API_URL_Artncraft+"/"+page)
  .then(res=>res.json())
  .then(data =>{
      if(data.success){
          if(data.responce.length === 0){
              setHasMore(false);
            }
            else{
              var sendData = [];
              for (let index = 0; index < items.length; index++) {
                const element = items[index];
                sendData.push(element);
              }
              for (let index = 0; index < data.responce.length; index++) {
                const element = data.responce[index];
                sendData.push(element);
              }
              setItems(sendData);
              setPage(page+1);
            }
      }
  })
}

const Newonkaaypage = (page,setPage,items,setItems,setHasMore)=>{
  fetch(ApiUrl.API_URL_Newonkaay+"/"+page)
  .then(res=>res.json())
  .then(data =>{
      if(data.success){
          if(data.responce.length === 0){
              setHasMore(false);
            }
            else{
              var sendData = [];
              for (let index = 0; index < items.length; index++) {
                const element = items[index];
                sendData.push(element);
              }
              for (let index = 0; index < data.responce.length; index++) {
                const element = data.responce[index];
                sendData.push(element);
              }
              setItems(sendData);
              setPage(page+1);
            }
      }
  })
}



export default {Kaayclosetpage,Artncraftpage,Newonkaaypage}